<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path d="M19.25 15C19.6642 15 20 15.3358 20 15.75C20 16.1297 19.7178 16.4435 19.3518 16.4932L19.25 16.5H16.5V19.25C16.5 19.6642 16.1642 20 15.75 20C15.3703 20 15.0565 19.7178 15.0068 19.3518L15 19.25V16.5H6.75C5.01697 16.5 3.60075 15.1435 3.50514 13.4344L3.5 13.25L3.499 5H0.75C0.335786 5 0 4.66421 0 4.25C0 3.8703 0.282154 3.55651 0.648229 3.50685L0.75 3.5H3.499L3.5 0.75C3.5 0.335786 3.83579 0 4.25 0C4.6297 0 4.94349 0.282154 4.99315 0.648229L5 0.75L4.999 3.5H5V5H4.999L5 13.25C5 14.1682 5.70711 14.9212 6.60647 14.9942L6.75 15H19.25ZM6 3.5H13.25C14.983 3.5 16.3992 4.85646 16.4949 6.56558L16.5 6.75V14H15V6.75C15 5.83183 14.2929 5.07881 13.3935 5.0058L13.25 5H6V3.5Z" />
  </svg>
</template>
